<template>
  <div class="pg-dialog-table-package-number">
    <div class="pg-dialog-table-package-number-text" v-if="!!url" @click="handleClick">
      <PgReadText :value="value" :type="type" :format="format" :symbol="symbol" />
      <i class="ivu-icon-icon-pg-edit pg-dialog-table-package-number-text-icon"></i>
    </div>
    <PgInputNumber v-else :value="value" @input="handleInput" :min="0" />
    <PgDialogTablePackage
      v-if="!!url"
      :visible.sync="visible"
      :url="tableData"
      :onOk="ok"
      :disabled="false"
      :columnTableCode="columnTableCode"
      :rowConfig="rowConfig"
      :seachKeys="['goodsStore.epc']"
      seachPlaceholder="扫码查找自定义序列号"
      defaultSearchIcon="ivu-icon-icon-pg-scan1"
      v-bind="$attrs"
    />
  </div>
</template>
<script setup>
import PgDialogTablePackage from './dialog-table-package.vue'
import { PgReadText } from '../../read-text/index'
import { PgInputNumber } from '../../input-number/index'
import { ref, shallowRef, computed } from 'vue'
import { clone } from '../../../utils/index.js'

const props = defineProps({
  value: [String, Array, Object, Number],
  type: '',
  format: '',
  symbol: '',
  // LOW_VALUE_PACKAGE / FIX_NUMBER_BOX / FIX_NUMBER_PACKAGE / UNIQUE_CODE
  epcType: String,
  url: [Array],
  onOk: Function,
})

const emit = defineEmits(['input'])
const handleInput = (val) => {
  console.log('handleInput', props.value)
  emit('input', val)
}

const rowConfig = computed(() => {
  if (props.epcType === 'FIX_NUMBER_BOX') return { height: 50 }
  if (props.epcType === 'UNIQUE_CODE') return { height: 28 }
  return {}
})
const columnTableCode = computed(() => {
  if (props.epcType === 'FIX_NUMBER_BOX') return 'LINK_FIX_NUMBER_BOX_COMMON_TABLE'
  if (props.epcType === 'UNIQUE_CODE') return 'LINK_UNIQUE_CODE_PACKAGE_COMMON_TABLE'
  if (props.epcType === 'FIX_NUMBER_PACKAGE') return 'LINK_UNIQUE_CODE_PACKAGE_COMMON_TABLE'
  if (props.epcType === 'LOW_VALUE_PACKAGE') return 'LINK_LOW_VALUE_PACKAGE_NUMBER_COMMON_TABLE'
  return ''
})
const tableData = shallowRef([])
const visible = ref(false)
const handleClick = () => {
  visible.value = true
  tableData.value = props.url ? clone(props.url) : []
}
const ok = (val) => {
  const removeData = props.url.filter((item) => !val.some((im) => im._ID === item._ID))
  const addData = val.filter((item) => !props.url.some((im) => im._ID === item._ID))
  const editData = val.filter((item) => props.url.some((im) => im._ID === item._ID))
  props.onOk?.({ editData, removeData, addData })
}
</script>
<style lang="scss">
@import '../style/dialog-table-package-number.scss';
</style>
